<template>
  <div class="info-modal-component">
    <div class="d-flex info-modal-header">
      <div class="title-modal">
        <p> {{ titleText }} </p>
      </div>
    </div>

    <div class="text-center">
      <img src="@/assets/images/calendar.svg">
    </div>

    <div class="content-modal">
      {{ contentText }}
    </div>

    <div v-if="buttonLabel" class="w-100 d-flex justify-content-center info-modal-footer">
      <b-button class="modal-confirm-btn" @click="emitEvent()"> {{ buttonLabel }} </b-button>
    </div>
  </div>
</template>
<script>
import InfoModal from "@/components/Util/InfoModal/InfoModalComponent";
export default InfoModal;
</script>

<style lang="scss">
@import "InfoModal.scss";
</style>
